"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("..");
const __2 = require("../..");
function DateInput({ children, disabled, error, hint, id, onChange, readOnly, showSelectOption, value }) {
    const hintId = `${id}--hint`;
    const monthId = `${id}--month`;
    const dayId = `${id}--day`;
    const yearId = `${id}--year`;
    const usedValue = {
        month: (value && value.month) || '',
        day: (value && value.day) || '',
        year: (value && value.year) || ''
    };
    const options = [
        '01 - January',
        '02 - February',
        '03 - March',
        '04 - April',
        '05 - May',
        '06 - June',
        '07 - July',
        '08 - August',
        '09 - September',
        '10 - October',
        '11 - November',
        '12 - December'
    ];
    return ((0, jsx_runtime_1.jsxs)(__1.Fieldset, { children: [(0, jsx_runtime_1.jsx)(__1.Legend, { error: error, children: children }), hint && (0, jsx_runtime_1.jsx)(__2.Hint, { id: hintId, children: hint }), error && (0, jsx_runtime_1.jsx)(__1.Form.Error, { error: error }), (0, jsx_runtime_1.jsxs)("div", { className: "usa-memorable-date", children: [(0, jsx_runtime_1.jsxs)("div", { className: "usa-form-group usa-form-group--month usa-form-group--select", children: [(0, jsx_runtime_1.jsx)(__1.Label, { error: error, target: monthId, children: "Month" }), (0, jsx_runtime_1.jsxs)("select", { "aria-describedby": hint ? hintId : undefined, className: "usa-select", disabled: disabled, id: monthId, name: monthId, onChange: onChange
                                    ? (event) => onChange({
                                        month: event
                                            .target.value
                                    })
                                    : undefined, value: usedValue.month, children: [showSelectOption && ((0, jsx_runtime_1.jsx)("option", { value: "", children: typeof showSelectOption === 'boolean'
                                            ? '- Select -'
                                            : showSelectOption.text })), options.map((option, index) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    (0, jsx_runtime_1.jsx)("option", { value: index, children: option }, `${id}--${index}`)))] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "usa-form-group usa-form-group--day", children: [(0, jsx_runtime_1.jsx)(__1.Label, { error: error, target: dayId, children: "Day" }), (0, jsx_runtime_1.jsx)("input", { "aria-describedby": hintId, className: "usa-input usa-input--inline", disabled: disabled, id: dayId, inputMode: "numeric", maxLength: 2, name: dayId, onChange: onChange
                                    ? (event) => onChange({ day: event.target.value })
                                    : undefined, pattern: "[0-9]*", readOnly: readOnly, type: "text", value: usedValue.day })] }), (0, jsx_runtime_1.jsxs)("div", { className: "usa-form-group usa-form-group--year", children: [(0, jsx_runtime_1.jsx)(__1.Label, { error: error, target: yearId, children: "Year" }), (0, jsx_runtime_1.jsx)("input", { "aria-describedby": hintId, className: "usa-input usa-input--inline", disabled: disabled, id: yearId, inputMode: "numeric", minLength: 4, maxLength: 4, name: yearId, onChange: onChange
                                    ? (event) => onChange({ year: event.target.value })
                                    : undefined, pattern: "[0-9]*", readOnly: readOnly, type: "text", value: usedValue.year })] })] })] }));
}
exports.default = DateInput;
